import { render } from "./LiveAppAccess.vue?vue&type=template&id=962ac09e"
import script from "./LiveAppAccess.vue?vue&type=script&lang=js"
export * from "./LiveAppAccess.vue?vue&type=script&lang=js"

import "./LiveAppAccess.vue?vue&type=style&index=0&id=962ac09e&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.5.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__